package Structs

import Utils.DatesManipulator
import Utils.getJsonWithConfig
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonArray
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.JsonPrimitive
import myName

@myName("RawPrice")
@Serializable
data class RawPrice(
    val id: Int,
    val product_id: Int,
    val price: Float,
    val date: String,
    val discount: Float,
    val master: Int? = null,
    /** User who wrote this price row (from client_prices.agent). */
    val agent: String? = null,
    /** When the row was written (from client_prices.action_time). */
    val action_time: String? = null,
) : Comparable<RawPrice> {
    override fun compareTo(other: RawPrice): Int {
        return date.compareTo(other.date)
    }

    fun toJson(): JsonObject {
        val map: MutableMap<String, JsonPrimitive> = mutableMapOf()
        map["id"] = JsonPrimitive(id.toString())
        map["product_id"] = JsonPrimitive(product_id.toString())
        map["price"] = JsonPrimitive(price.toString())
        map["date"] = JsonPrimitive(date)
        map["discount"] = JsonPrimitive(discount.toString())
        if (master != null) map["master"] = JsonPrimitive(master.toString())
        // agent / action_time are read-only audit fields; inserts set agent from the JWT.
        return JsonObject(map)
    }

    companion object {
        fun newPriceDate(id: Int, product_id: Int, price: Float, date: String?, discount: Float): RawPrice {
            var finalDate: String? = date
            if (date == null) {

                finalDate = DatesManipulator.dateNowNoHour()
            }
            return RawPrice(id, product_id, price, finalDate!!, discount)

        }

        /**
         * Builds [RawPrice] rows for [DataBase.NKDBInterface._updateClientsPrice] from priced API [delivery_prices].
         * Only lines with **ci ≠ 0** are included (skips note line `u`≥1 and order p>0; utn+paid rows keep ci).
         * [RawPrice.id] is **ci** (client / master / price_control id for the resolved ladder), not the note [ent_id].
         */
        fun fromDeliveryPricesJsonForClientPriceTable(noteDate: String, deliveryPricesJson: String?): List<RawPrice> {
            val js = deliveryPricesJson?.trim() ?: return emptyList()
            if (js.isEmpty() || js == "null" || js == "[]") return emptyList()
            val arr = try {
                getJsonWithConfig().parseToJsonElement(js.replace("\\'", "'")) as? JsonArray
            } catch (_: Exception) {
                null
            } ?: return emptyList()
            val out = ArrayList<RawPrice>(arr.size)
            for (el in arr) {
                val obj = el as? JsonObject ?: continue
                val priceTableId = jsonPrimitiveToInt(obj["ci"]) ?: 0
                if (priceTableId == 0) continue
                val productId = jsonPrimitiveToInt(obj["id"]) ?: continue
                val cp = jsonPrimitiveToFloat(obj["cp"]) ?: continue
                val cd = jsonPrimitiveToFloat(obj["cd"]) ?: 0f
                out.add(RawPrice(priceTableId, productId, cp, noteDate, cd))
            }
            return out
        }

        private fun jsonPrimitiveToFloat(el: JsonElement?): Float? {
            if (el == null) return null
            val p = el as? JsonPrimitive ?: return null
            return p.content.toFloatOrNull()
        }

        private fun jsonPrimitiveToInt(el: JsonElement?): Int? {
            if (el == null) return null
            val p = el as? JsonPrimitive ?: return null
            val c = p.content
            return c.toIntOrNull() ?: c.toFloatOrNull()?.toInt()
        }
    }
}